import { put, all, takeLatest, select } from "redux-saga/effects";
import * as types from "~/store/invoice/types";
import { client } from "~/utils/medproSDK";
import { get } from "lodash";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";

function* searchElectricInvoices({ data }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const partnerId = yield select(state => state.totalData.partnerId);
    const response = yield client.getInvoices(data, {
      partnerid: partnerId,
      platform
    });
    yield put({
      type: types.SEARCH_ELECTRIC_INVOICES_SUCCESS,
      payload: response.data
    });
    history.push("/danh-sach-hoa-don-dien-tu");
  } catch (error) {
    console.log(error);
    const message = get(error, "response.data.message");
    openToast(message, "error");
    yield put({
      type: types.SEARCH_ELECTRIC_INVOICES_FAILURE,
      error
    });
  }
}

function* sendEmailInvoice({ data }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    yield client.sendMailInvoice({ data }, { platform });
    openToast("Đã gửi Email thành công!");
    yield put({
      type: types.SEND_EMAIL_INVOICE_SUCCESS
    });
  } catch (error) {
    console.log(error);
    const message = get(error, "response.data.message");
    openToast(message, "error");
    yield put({
      type: types.SEND_EMAIL_INVOICE_FAILURE
    });
  }
}

export default function* watcher() {
  yield all([
    takeLatest(types.SEARCH_ELECTRIC_INVOICES, searchElectricInvoices),
    takeLatest(types.SEND_EMAIL_INVOICE, sendEmailInvoice)
  ]);
}
